import React from "react";
import ReactModal from "react-modal";
import useForm, { Form } from "../../../components/controls/useForm";
import Controls from "../../../components/controls/control";
import FormLabel from "../../../components/HtmlMarkup/FormLabel";
import { useSelector } from "react-redux";
import { useGetAssignmentWithVideoIdQuery } from "../../../features/Student/CoursePlayer/coursePlayerApi";

const initializeValues = {
  repo: "",
};
export default function AssignmentModal({ modalIsOpen, closeModal }) {
  const { videoId } = useSelector((state) => state.coursePlayer);

  const { data: assignments } = useGetAssignmentWithVideoIdQuery(videoId);

  const { values, setValues, handleInputChange, resetForm } =
    useForm(initializeValues);
  const customStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
    content: {
      backgroundColor: "#1E293B",
    },
  };
  const handleSubmit = (e) => {
    e.preventDefault();
  };
  return (
    <ReactModal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      style={customStyles}
    >
      <div className="py-6 grid place-items-center">
        <h1 className="mb-10 text-center lws-section-title">
          Submit Assignment
        </h1>

        <div className="max-w-3xl mx-auto">
          <Form onSubmit={handleSubmit} className="space-y-6">
            <div className="fieldContainer">
              <FormLabel htmlFor={"title"}>Repo</FormLabel>
              <Controls.Input
                id="repo"
                name="repo"
                autocomplete="repo"
                className="login-input rounded-t-md"
                placeholder="Assignment repo link"
                type={"url"}
                value={values.repo}
                onChange={handleInputChange}
              />
            </div>
            <div className="text-right ">
              <Controls.Button
                text={"Submit"}
                type="submit"
                className="mt-24 group relative w-full flex justify-center items-center py-2 px-4 border border-transparent text-sm font-bold rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
              />
              <Controls.Button
                onClick={closeModal}
                text={<span className="ml-2">Cancel</span>}
                className="mt-4 group relative w-full flex justify-center items-center py-2 px-4 border border-transparent text-sm font-bold rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
              />
            </div>
          </Form>
        </div>
      </div>
    </ReactModal>
  );
}
